import { createContext, useContext } from "react";

/**
 * Whether a box's opener hero (`BoxHero`) carries the box's heading: its name, price and meta. On
 * by default, as on the split box page, where the hero carries it while it's up and the page's
 * heading section steps aside (`inHero`). A layout that keeps its heading section in place (the
 * stacked box page, which sets the name above the box) turns it off, and the hero leaves it out.
 */
export const BoxHeroHeadingContext = createContext(true);

/** Whether a hero below draws the box's heading. */
export function useBoxHeroHeading(): boolean {
  return useContext(BoxHeroHeadingContext);
}
